'use client';
import { NotiDataType } from "@/core/models/notification";
import NotificationContext from "./context";
import { useState } from "react"

const timeObject = new Date();
export const mockDataNotification = [
  {
    id: '1',
    type: 0,
    title: 'Login attempted from new IP',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: false,
    time: new Date(timeObject.getTime() - 40 * 1000)
  },
  {
    id: '2',
    type: 1,
    title: 'Detecting Account Takeover Attacks',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: false,
    time: new Date(timeObject.getTime() - 34 * 60 * 1000)
  },
  {
    id: '3',
    type: 2,
    title: 'Notice of removal of trading consectetur adipiscing',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: false,
    time: new Date(timeObject.getTime() - 3 * 60 * 60 * 1000)
  },
  {
    id: '4',
    type: 0,
    title: 'Login attempted from new IP',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: true,
    time: new Date(timeObject.getTime() - 7 * 60 * 60 * 1000)
  },
  {
    id: '5',
    type: 1,
    title: 'Detecting Account Takeover Attacks',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: true,
    time: new Date('2023-07-25')
  },
  {
    id: '6',
    type: 1,
    title: 'Detecting Account Takeover Attacks',
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    read: true,
    time: new Date('2023-07-22 22:00')
  },
]

export default function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false)
  const [action, setAction] = useState<string>('')
  const [dataNotification, setDataNotification] = useState<NotiDataType[]>(mockDataNotification)
  return (
    <NotificationContext.Provider value={{
      openConfirmModal: openConfirmModal,
      action: action,
      dataNotification: dataNotification,
      setOpenConfirmModal: setOpenConfirmModal,
      setAction: setAction,
      setDataNotification: setDataNotification
    }}>
      {children}
    </NotificationContext.Provider>
  )
}
